var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { Label } from '@/models/Label';
import { TreatmentLabel } from '@/models/TreatmentLabel';
import { excludeRoles } from '@/support/ExcludeRoles';
import ErrorHandler from '@/support/ErrorHandler';
import { Setting as SettingModel } from '@/models/Setting';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { cloneDeep } from 'lodash';
import AddPlanStatusDialog from '@/components/AddPlanStatusDialog/AddPlanStatusDialog';
import { StudentDocumentStatus } from '@/models/StudentDocumentStatus';
import { RolesEnum } from '@/items/Roles';
let SchoolSettings = class SchoolSettings extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        this.statusLabels = [];
        this.isAddingPlanStatus = false;
        this.planStatuses = [];
        this.isLoadingPlanStatuses = true;
        this.treatmentLabelsLoaded = false;
        this.treatmentLabels = [];
        this.isEditingVersion = false;
        this.parnassysNumber = null;
        this.parnassysNumberClone = new SettingModel();
        this.isEdittingParnassys = false;
        this.isEdittingPlp = false;
        this.prioritySubjectsLabelSetting = '';
        this.versions = [
            { value: '1' || 1, text: 'Mijnleerlijn' },
            { value: '4' || 4, text: 'Portfolio blokken' },
            { value: '2' || 2, text: 'Portfolio periode' },
            { value: '3' || 3, text: 'Rooster' },
        ];
        this.mailSettings = [
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'has_roster',
                        value: true,
                    },
                ]
                : []),
        ];
        this.guardianSettings = [
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_scooltracker',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_this_is_me',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_portfolio',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_finished',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_profile',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_notes',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('3')
                ? [
                    {
                        key: 'guardian_can_see_student_roster',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_use_chat_functions',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_lvs',
                        value: false,
                    },
                ]
                : []),
        ];
        this.parnassysSettings = {};
        this.parnassysSettingsClone = {};
        this.mfaSettings = {};
        this.mfaSettingsClone = {};
        this.version = {};
        this.studentSettings = {
            student_can_set_goal_to_yellow: false,
        };
        this.scoolSettings = {
            hide_my_roster: false,
        };
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolAdmin.schools.settings.version.includes(this.$store.state.Auth.roles[0].id);
    }
    get versionValue() {
        return this.versions.find((version) => {
            return version.value == this.$store.state.version;
        });
    }
    get canSeeParnassys() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get canSeeMfa() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.RESELLER]);
    }
    get dialogOptionsVersion() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.switchedVersion', { version: this.version.text }).toString(),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        window.location.reload();
                    },
                },
            },
        };
    }
    parseSettings() {
        const studentCanEditGoalToYellow = this.getSetting('student_can_set_goal_to_yellow');
        const hideMyRoster = this.getSetting('hide_my_roster');
        if (hideMyRoster) {
            this.scoolSettings.hide_my_roster = hideMyRoster.value;
        }
        const setting = this.getSetting('priority_subjects_label');
        this.mailSettings.forEach((mailSetting) => {
            if (mailSetting.key === undefined) {
                return;
            }
            const currentSetting = this.$store.state.settings.find((setting) => {
                return setting.key === mailSetting.key;
            });
            if (currentSetting) {
                mailSetting.value = currentSetting.value === '1' || currentSetting.value === true ? true : false;
            }
        });
        this.guardianSettings.forEach((guardianSetting) => {
            if (guardianSetting.key === undefined) {
                return;
            }
            const currentSetting = this.$store.state.settings.find((setting) => {
                return setting.key === guardianSetting.key;
            });
            if (currentSetting) {
                guardianSetting.value = currentSetting.value === '1' || currentSetting.value === true ? true : false;
            }
        });
    }
    mounted() {
        this.initialize();
    }
    destroyed() {
        this.fetchSettings();
    }
    async initialize() {
        this.isLoading = true;
        this.fetchPlanStatuses();
        this.fetchParnassysSettings();
        this.fetchMfaSettings();
        this.fetchPrioritySubjectsLabelSetting();
        this.parseSettings();
        this.fetchSchoolVersion();
        this.fetchLabels();
        this.fetchTreatmentLabels();
        this.isLoading = false;
    }
    fetchPrioritySubjectsLabelSetting() {
        const setting = this.getSetting('priority_subjects_label');
        if (!setting) {
            // we set a default value if it doesn't have one
            this.updateSettings('priority_subjects_label', 'MijnVoorrang');
            this.prioritySubjectsLabelSetting = 'MijnVoorrang';
        }
        else {
            this.prioritySubjectsLabelSetting = setting.value;
        }
    }
    fetchParnassysSettings() {
        const settingsKey = [
            'parnassys_brinnummer',
            'parnassys_sync_guardians',
            'parnassys_sync_teachers',
            'parnassys_auto_sync_teachers',
            'parnassys_auto_sync_guardians',
            'parnassys_auto_sync_students',
        ];
        settingsKey.forEach((key) => {
            const foundSetting = this.$store.getters.getSetting(key);
            if (foundSetting) {
                this.parnassysSettings[key] = foundSetting.value;
            }
            else {
                // Prefill
                this.parnassysSettings[key] = null;
            }
        });
        this.parnassysSettingsClone = cloneDeep(this.parnassysSettings);
    }
    fetchMfaSettings() {
        const settingsKey = ['mfa_teachers', 'mfa_students', 'mfa_guardians'];
        settingsKey.forEach((key) => {
            const foundSetting = this.$store.getters.getSetting(key);
            if (foundSetting) {
                this.mfaSettings[key] = foundSetting;
            }
            else {
                this.mfaSettings[key] = {
                    value: '',
                };
            }
        });
        this.mfaSettingsClone = cloneDeep(this.mfaSettings);
    }
    getSetting(key) {
        return this.$store.getters.getSetting(key);
    }
    async fetchSettings() {
        /*
        TODO: @Stefano this is called on component.destroyed. Refetching Settings; so that
                  switches displayed correctly when switching between tabs.
                  Might cause issues - was not in the original code - as, there was no tab switching.
        */
        const settings = await new SettingModel()
            .limit(200)
            .all();
        this.$store.dispatch('loadedSettings', settings);
    }
    isVersion(version) {
        return version == this.$store.state.version;
    }
    fetchLabels() {
        new Label().all().then((labels) => {
            this.$store.dispatch('loadedLabels', labels);
            this.statusLabels = [];
            Object.keys(this.$t('idp.status')).forEach((status) => {
                const setting = this.$store.state.labels.find((label) => {
                    return label.key === status;
                });
                if (setting) {
                    setting.editing = false;
                    this.statusLabels.push(setting);
                }
                else {
                    this.statusLabels.push(new Label({ key: status, value: status, editing: false }));
                }
            });
        });
    }
    fetchTreatmentLabels() {
        this.treatmentLabelsLoaded = false;
        new TreatmentLabel().all().then((treatmentLabels) => {
            this.$store.dispatch('loadedTreatmentLabels', treatmentLabels);
            this.treatmentLabels = [];
            Object.keys(this.$t('idp.treatment')).forEach((treatment) => {
                const setting = this.$store.state.treatment_labels.find((label) => {
                    return label.key === treatment;
                });
                if (setting) {
                    setting.editing = false;
                    this.treatmentLabels.push(setting);
                }
                else {
                    this.treatmentLabels.push(new TreatmentLabel({ key: treatment, value: '', editing: false }));
                }
            });
            this.treatmentLabelsLoaded = true;
        });
    }
    onClickUpdatePrioSubjectLabel() {
        this.updateSettings('priority_subjects_label', this.prioritySubjectsLabelSetting);
        this.isEdittingPlp = false;
    }
    updateSettings(key, value) {
        const payload = { key, value };
        if ([
            'mfa_teachers',
            'mfa_students',
            'mfa_guardians',
        ].includes(key)) {
            payload.cast = 'boolean';
        }
        new SettingModel()
            .update([payload])
            .then(async (settings) => {
            await this.fetchSettings();
            if (key in this.parnassysSettings) {
                // console.log('HERE');
                this.fetchParnassysSettings();
                this.isEdittingParnassys = false;
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    updateLabel(label) {
        const value = !label.value ? label.key : label.value;
        new Label()
            .put([{ key: label.key, value }])
            .then(() => {
            this.fetchLabels();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    // TODO
    addPlanStatus() {
        this.isAddingPlanStatus = true;
    }
    async fetchPlanStatuses() {
        this.isLoadingPlanStatuses = true;
        this.planStatuses = await new StudentDocumentStatus().all();
        this.isLoadingPlanStatuses = false;
    }
    async deletePlanStatus(index) {
        const planStatus = this.planStatuses[index];
        try {
            await planStatus.delete();
            await this.fetchPlanStatuses();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    updateTreatmentLabel(treatmentLabel) {
        const value = !treatmentLabel.value ? treatmentLabel.key : treatmentLabel.value;
        new TreatmentLabel()
            .updateTreamentLabels([{ key: treatmentLabel.key ? treatmentLabel.key : treatmentLabel.value, value: value || '' }])
            .then(() => {
            this.fetchTreatmentLabels();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    updateVersion(version) {
        const payload = {
            key: 'scool_version',
            value: version.value,
        };
        new SettingModel()
            .update([payload])
            .then((setting) => {
            this.$store.dispatch('loadedVersion', version.value);
            this.$store.dispatch('openDialog', this.dialogOptionsVersion);
            this.isEditingVersion = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    fetchSchoolVersion() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'scool_version';
        });
        return (this.version = {
            value: setting ? setting.value : 3,
            text: setting ? setting.value.toString() : '3',
        });
    }
    get canEditBrinNumber() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT]);
    }
    get canSeeBrinNumber() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]);
    }
    get isParnassysDisabled() {
        return !this.$store.state.Auth.hasRole([RolesEnum.ROOT]);
    }
};
SchoolSettings = __decorate([
    Component({
        components: {
            PageHeader,
            LoaderCard,
            AddPlanStatusDialog,
        },
    })
], SchoolSettings);
export default SchoolSettings;
